module.exports = __webpack_public_path__ + "static/media/8.4b494bb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/8.png
// module id = 856
// module chunks = 0